import { clientPortalApi } from 'src/api';
import { UpdatePublicKeyRequest } from 'src/types';

export const updateCurrentUserSshPublicKey = (data: UpdatePublicKeyRequest) =>
  clientPortalApi.post<string>('/api/v1/users/ssh-keys/public', data);
